import React, { FC, useEffect, useState } from 'react';

import { IGroupEnrollment } from '../../../store/player/games/store';

import { userPic } from '../../../assets/images';

interface IProps {
  item: IGroupEnrollment;
}

const RoundScoreSummaryPlayerDescription: FC<IProps> = props => {
  const { item } = props;

  const user = item && item.user;

  const [imageSource, setImageSource] = useState(userPic);
  const [userFullName, setuserFullName] = useState('');

  useEffect(() => {
    if (user) {
      if (user.profile.image) {
        setImageSource(user.profile.image);
      }

      setuserFullName(`${user.firstName} ${user.lastName}`);
    }
  }, [user]);

  return (
    <div className="head">
      <img src={imageSource} alt={`${userFullName}`} />

      <div className="scorer-name">
        <span>{userFullName}</span>
      </div>
    </div>
  );
};

export default RoundScoreSummaryPlayerDescription;
